/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetFutureReservations200ResponseInner
 */
export interface GetFutureReservations200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetFutureReservations200ResponseInner
     */
    name: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetFutureReservations200ResponseInner
     */
    surname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetFutureReservations200ResponseInner
     */
    phoneNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetFutureReservations200ResponseInner
     */
    email: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetFutureReservations200ResponseInner
     */
    dateTime: string;
    /**
     * 
     * @type {number}
     * @memberof GetFutureReservations200ResponseInner
     */
    diners: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetFutureReservations200ResponseInner
     */
    tables?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GetFutureReservations200ResponseInner
     */
    customerComments?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetFutureReservations200ResponseInner
     */
    zone: string;
    /**
     * 
     * @type {string}
     * @memberof GetFutureReservations200ResponseInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetFutureReservations200ResponseInner
     */
    status: GetFutureReservations200ResponseInnerStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GetFutureReservations200ResponseInner
     */
    source: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetFutureReservations200ResponseInner
     */
    policy: GetFutureReservations200ResponseInnerPolicyEnum;
    /**
     * 
     * @type {number}
     * @memberof GetFutureReservations200ResponseInner
     */
    policyAmount: number;
    /**
     * 
     * @type {string}
     * @memberof GetFutureReservations200ResponseInner
     */
    policyMethod?: GetFutureReservations200ResponseInnerPolicyMethodEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetFutureReservations200ResponseInner
     */
    policyCharged: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetFutureReservations200ResponseInner
     */
    endTime: string;
    /**
     * 
     * @type {string}
     * @memberof GetFutureReservations200ResponseInner
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof GetFutureReservations200ResponseInner
     */
    creationTime: string;
    /**
     * 
     * @type {string}
     * @memberof GetFutureReservations200ResponseInner
     */
    tabId: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetFutureReservations200ResponseInner
     */
    rating?: number;
    /**
     * 
     * @type {string}
     * @memberof GetFutureReservations200ResponseInner
     */
    comment?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetFutureReservations200ResponseInner
     */
    price?: number;
}


/**
 * @export
 */
export const GetFutureReservations200ResponseInnerStatusEnum = {
    Processing: 'processing',
    Pending: 'pending',
    Confirmed: 'confirmed',
    Ongoing: 'ongoing',
    Cancelled: 'cancelled',
    NoShow: 'no-show',
    Finished: 'finished'
} as const;
export type GetFutureReservations200ResponseInnerStatusEnum = typeof GetFutureReservations200ResponseInnerStatusEnum[keyof typeof GetFutureReservations200ResponseInnerStatusEnum];

/**
 * @export
 */
export const GetFutureReservations200ResponseInnerPolicyEnum = {
    Card: 'card',
    Deposit: 'deposit',
    None: 'none'
} as const;
export type GetFutureReservations200ResponseInnerPolicyEnum = typeof GetFutureReservations200ResponseInnerPolicyEnum[keyof typeof GetFutureReservations200ResponseInnerPolicyEnum];

/**
 * @export
 */
export const GetFutureReservations200ResponseInnerPolicyMethodEnum = {
    All: 'all',
    ByPerson: 'by-person',
    LargeGroups: 'large-groups'
} as const;
export type GetFutureReservations200ResponseInnerPolicyMethodEnum = typeof GetFutureReservations200ResponseInnerPolicyMethodEnum[keyof typeof GetFutureReservations200ResponseInnerPolicyMethodEnum];


/**
 * Check if a given object implements the GetFutureReservations200ResponseInner interface.
 */
export function instanceOfGetFutureReservations200ResponseInner(value: object): value is GetFutureReservations200ResponseInner {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('dateTime' in value) || value['dateTime'] === undefined) return false;
    if (!('diners' in value) || value['diners'] === undefined) return false;
    if (!('zone' in value) || value['zone'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    if (!('policy' in value) || value['policy'] === undefined) return false;
    if (!('policyAmount' in value) || value['policyAmount'] === undefined) return false;
    if (!('policyCharged' in value) || value['policyCharged'] === undefined) return false;
    if (!('endTime' in value) || value['endTime'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('creationTime' in value) || value['creationTime'] === undefined) return false;
    if (!('tabId' in value) || value['tabId'] === undefined) return false;
    return true;
}

export function GetFutureReservations200ResponseInnerFromJSON(json: any): GetFutureReservations200ResponseInner {
    return GetFutureReservations200ResponseInnerFromJSONTyped(json, false);
}

export function GetFutureReservations200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFutureReservations200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'surname': json['surname'] == null ? undefined : json['surname'],
        'phoneNumber': json['phoneNumber'],
        'email': json['email'],
        'dateTime': json['dateTime'],
        'diners': json['diners'],
        'tables': json['tables'] == null ? undefined : json['tables'],
        'customerComments': json['customerComments'] == null ? undefined : json['customerComments'],
        'zone': json['zone'],
        'id': json['id'],
        'status': json['status'],
        'source': json['source'],
        'policy': json['policy'],
        'policyAmount': json['policyAmount'],
        'policyMethod': json['policyMethod'] == null ? undefined : json['policyMethod'],
        'policyCharged': json['policyCharged'],
        'endTime': json['endTime'],
        'updatedAt': json['updatedAt'],
        'creationTime': json['creationTime'],
        'tabId': json['tabId'],
        'rating': json['rating'] == null ? undefined : json['rating'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'price': json['price'] == null ? undefined : json['price'],
    };
}

export function GetFutureReservations200ResponseInnerToJSON(json: any): GetFutureReservations200ResponseInner {
    return GetFutureReservations200ResponseInnerToJSONTyped(json, false);
}

export function GetFutureReservations200ResponseInnerToJSONTyped(value?: GetFutureReservations200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'surname': value['surname'],
        'phoneNumber': value['phoneNumber'],
        'email': value['email'],
        'dateTime': value['dateTime'],
        'diners': value['diners'],
        'tables': value['tables'],
        'customerComments': value['customerComments'],
        'zone': value['zone'],
        'id': value['id'],
        'status': value['status'],
        'source': value['source'],
        'policy': value['policy'],
        'policyAmount': value['policyAmount'],
        'policyMethod': value['policyMethod'],
        'policyCharged': value['policyCharged'],
        'endTime': value['endTime'],
        'updatedAt': value['updatedAt'],
        'creationTime': value['creationTime'],
        'tabId': value['tabId'],
        'rating': value['rating'],
        'comment': value['comment'],
        'price': value['price'],
    };
}

